"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var dayjs_1 = __importDefault(require("dayjs"));

var relativeTime_1 = __importDefault(require("dayjs/plugin/relativeTime"));

dayjs_1.default.extend(relativeTime_1.default);

function addDays(date, days) {
  return dayjs_1.default(date).add(days, 'day').toDate();
}

exports.addDays = addDays;

function addMonths(date, months) {
  return dayjs_1.default(date).add(months, 'month').toDate();
}

exports.addMonths = addMonths;

function getHoursAgo(date) {
  return (new Date().getTime() - date.getTime()) / (1000 * 60 * 60);
}

exports.getHoursAgo = getHoursAgo;

function getDaysAgo(date) {
  return Math.floor(getHoursAgo(date) / 24);
}

exports.getDaysAgo = getDaysAgo;

function fromNow(date) {
  return dayjs_1.default(date).fromNow();
}

exports.fromNow = fromNow;

function fullDaysUntil(date) {
  var daysInteger = Math.ceil((date.getTime() - new Date().getTime()) / (1000 * 60 * 60 * 24));
  if (daysInteger < 0) return 'ERROR';
  return daysInteger > 0 ? "in " + daysInteger + " days" : 'today';
}

exports.fullDaysUntil = fullDaysUntil;

function formatForS3Key(date, withTime) {
  var dateString = formatDateOnly(date);

  if (withTime === true) {
    dateString += "-" + ("0" + date.getHours()).slice(-2) + ("0" + date.getMinutes()).slice(-2);
  }

  return dateString;
}

exports.formatForS3Key = formatForS3Key;

function formatDateOnly(date, seperator) {
  var actualSeperator = seperator || '';
  return date.getFullYear() + actualSeperator + ("0" + (date.getMonth() + 1)).slice(-2) + actualSeperator + ("0" + date.getDate()).slice(-2);
}

exports.formatDateOnly = formatDateOnly;

function compareDatePart(a, b) {
  return formatDateOnly(a).localeCompare(formatDateOnly(b));
}

exports.compareDatePart = compareDatePart;